import React, { useCallback, useContext, useEffect, useState } from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { Link } from "react-router-dom";
import { getTrans as T } from "../../../../Shared/Language";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import {
  deleteFeedPost,
  feedCommentList,
  feedPostComment,
  getReportPost,
  convertToFeaturePost,
  feedLikePost,
  getFeaturedPostFeed,
  postMarkFeatured,
  getPopularPostFeed,
  getFeed,
  getFeedCount,
  postMarkUnFeatured,
} from "../Services/DashboardServices";
import moment from "moment";
import { uploadDoc } from "../../../../Services/Global-Services/GlobalServices";
import { TostMsg } from "../../../../App";
import { useFormik } from "formik";
import * as Yup from "yup";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import InfiniteScroll from "react-infinite-scroll-component";
import { PostDate } from "../CommonComponents/PostDate";
import Commnent from "../../../../Services/Comment/comment";
import ERROR_LIST from "../../../../Services/Global-Services/Hadle_Errors";
import FollowUpSuggestions from "../FollowUpSuggestions/FollowUpSuggestions";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { DashboardFeatureAndPopularPost } from "./FeaturePostSlider";
import { DashboardPopularPost } from "./PopularPostSlider";
import FeedPost from "../DashboardFeed/FeedPost";
import Skeleton from "react-loading-skeleton";
import UploadFile_KEYS from "../../../../Services/Global-Services/UploadFile_Keys";
import { setFeedRequestData } from "../../../../Services/Redux/DataTransferToAnother";
import { useDispatch } from "react-redux";

const FeedCarousel = React.lazy(() =>
  import("../DashboardFeed/FeedCarousel").then((module) => ({
    default: module.FeedCarousel,
  }))
);
const defaultImage = "/images/placeholder_profile.png";
let MakeFeaturedFeedId;
let MyPostParams;
let CheckURL;
let isFeaturedType;

const FeaturedPost = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  let history = useHistory();
  const toster = useContext(TostMsg);
  const [Isloading, setIsLoading] = useState(false);
  const [IsUserCountloading, setIsUserCountloading] = useState(false);
  const [feedLst, setFeedLst] = useState([]);
  const [ImagePath, setImagePath] = useState([]);
  const [employee, setEmployee] = useState([]);
  const [mentionedArr, setMentionedArr] = useState([]);
  const [selectedFeedText, setSelectedFeedText] = useState([]);
  const [feedText, setFeedText] = useState("");
  const [postFile, setPostFile] = useState(null);
  const [uploadedPostImages, setUploadedPostImages] = useState([]);
  const [feedId, setFeedId] = useState(0);
  const [page, setPage] = useState(1);
  const [updatedPage, setUpdatedPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [feedEmployeeDetails, setFeedEmployeeDetails] = useState([]);
  const location = useLocation();
  const [feedCount, setFeedCount] = useState([]);
  const [userDetail, setUserDetail] = useState([]);
  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");
  const [featuredPostEdit, setFeaturedPostEdit] = useState(false);
  const [featuredPostReport, setFeaturedPostReport] = useState(false);
  const [featuredPostDelete, setFeaturedPostDelete] = useState(false);
  const [featuredPostFeatured, setFeaturedPostFeatured] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [isSecondLoading, setSecondLoading] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentTime, setCurrentTime] = useState(new Date());
  const dispatch = useDispatch();
  const [visibleId, setVisibleId] = useState(null);
  const [editFeedLst, setEditFeedLst] = useState(null);

  useEffect(() => {
    const timerId = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  useEffect(() => {
    window?.scrollTo(0, 0);
    CheckURL = location?.pathname?.slice(0, 10);
    MyPostParams = location?.pathname?.split("User/")[1];
    fetchData();
    fetchEmployeeData();
    if (location?.pathname != "/Feed/User") {
      GetFeedCount(userDetails?.EmpId, userDetails?.OrgId);
      setUserDetail({
        UserName: userDetails?.FullName,
        UserImage: userDetails?.ProfileImage,
        GUID: userDetails?.GUID,
      });
    }
    permissionFeaturedPostGranted();
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [location?.pathname]);

  const handleClickOutside = (event) => {
    if (!event.target.closest(".dropdown")) {
      setVisibleId(null);
    }
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  const handalClosePopup = () => {
    document.querySelector("#report-img .btn-close")?.click();
    reportPostForm.resetForm();
  };
  const addReportPost = () => {
    reportPostForm.resetForm();
  };
  const handleDeleteImage = () => {
    setUploadedPostImages([]);
  };
  const handleResponseFromB = (response) => {
    if (response) {
      dispatch(setFeedRequestData(response));
      setFeedLst([]);
      setUpdatedPage(1);
      setPage(1);
      setHasMore(true);
      if (location?.pathname == "/Feed/Featured") {
        GetFeaturedPost(true);
      } else if (location?.pathname == "/Feed/Popular") {
        GetPopularPost(true);
      } else {
        GetFeed(true);
      }
    }
  };

  const fetchData = async () => {
    await setUpdatedPage(1);
    if (location?.pathname == "/Feed/Featured") {
      await GetFeaturedPost(true);
    } else if (location?.pathname == "/Feed/Popular") {
      await GetPopularPost(true);
    } else {
      await GetFeed(true);
    }
    await FeedCommentList();
  };

  const toggleVisibility = (id) => {
    setVisibleId((prevId) => (prevId === id ? null : id));
  };

  const handleLastName = (name) => {
    if (name == "success") {
      setUpdatedPage(1);
      GetFeaturedPost(false);
    }
  };

  //Get Feed List
  async function GetFeaturedPost(reset = false) {
    if (isFetching) return;
    setIsFetching(true);
    if (reset) {
      setIsLoading(true);
    } else {
      setSecondLoading(true);
    }
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      EmpGUID: "",
      FeedId: 0,
      FeedGUID: "",
      pageNumber: reset ? 1 : page,
      pageSize: 25,
      LoggedInUserId: userDetails?.EmpId,
    };
    try {
      let Feedlst = await getFeaturedPostFeed(body);
      Feedlst = Feedlst?.Data;
      if (reset) {
        setFeedLst(Feedlst);
        setPage(2);
      } else {
        if (Feedlst.length === 0) {
          setHasMore(false);
        } else {
          setFeedLst((prev) => [...prev, ...Feedlst]);
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST?.DashboardFeed);
    } finally {
      setIsLoading(false);
      setIsFetching(false);
      setSecondLoading(false);
    }
  }

  async function GetPopularPost(reset = false) {
    if (isFetching) return;
    setIsFetching(true);
    if (reset) {
      setIsLoading(true);
    } else {
      setSecondLoading(true);
    }
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      FeedId: 0,
      EmpGUID: "",
      pageNumber: reset ? 1 : page,
      pageSize: 25,
      LoggedInUserId: userDetails?.EmpId,
      FeedGUID: "",
    };
    try {
      let Feedlst = await getPopularPostFeed(body);
      let feedlist = Feedlst?.Data?.filter(
        (el) => el?.CreatedBy == userDetails?.EmpId || []
      );
      if (reset) {
        setFeedLst(feedlist);
        setPage(2);
        setHasMore(feedlist.length === 25);
      } else {
        if (feedlist.length < 25) {
          setHasMore(false);
        }
        setFeedLst((data) => [...data, ...feedlist]);
        if (feedlist.length === 25) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST?.DashboardFeed);
    } finally {
      setIsLoading(false);
      setIsFetching(false);
      setSecondLoading(false);
    }
  }

  async function GetFeed(reset = false) {
    if (isFetching) return;
    setIsFetching(true);
    if (reset) {
      setIsLoading(true);
    } else {
      setSecondLoading(true);
    }
    const body = {
      OrgId: userDetails?.OrgId,
      EmpId: 0,
      FeedId: 0,
      EmpGUID: MyPostParams,
      IsFeatures: 0,
      pageNumber: reset ? 1 : page,
      pageSize: 25,
      LoggedInUserId: userDetails?.EmpId,
      FeedGUID: "",
    };
    try {
      let Feedlst = await getFeed(body);
      let feedlist =
        Feedlst?.Data?.map((el) => ({ ...el, isChecked: !!el.IsFeatures })) ||
        [];
      GetFeedCount(feedlist[0]?.CreatedBy, feedlist[0]?.OrgId);
      setUserDetail({
        UserName: feedlist[0]?.PostedBy,
        UserImage: feedlist[0]?.ProfilePic,
        GUID: feedlist[0]?.PostedByGUID,
      });
      if (reset) {
        setFeedLst(feedlist);
        setPage(2);
        setHasMore(feedlist.length === 25);
      } else {
        if (feedlist.length < 25) {
          setHasMore(false);
        }
        setFeedLst((prev) => [...prev, ...feedlist]);
        if (feedlist.length === 25) {
          setPage((prev) => prev + 1);
        }
      }
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST?.DashboardFeed);
    } finally {
      setIsLoading(false);
      setIsFetching(false);
      setSecondLoading(false);
    }
  }

  const DeleteFeedPost = async () => {
    if (deleteId) {
      let body = {
        Id: deleteId,
      };
      const previousFeedLst = [...feedLst];
      setFeedLst((prev) => {
        const newList = prev.filter((item) => item.Id !== deleteId);
        return newList;
      });
      try {
        await deleteFeedPost(body);
        setUpdatedPage(1);
        setFeedLst([]);
        setPage(1);
        setHasMore(true);
        setDeleteId(null);
        dispatch(setFeedRequestData(body));
        if (location?.pathname == "/Feed/Featured") {
          toster.current.success("Featured feed deleted successfully.");
          GetFeaturedPost(true);
        } else if (location?.pathname == "/Feed/Popular") {
          toster.current.success("Popular feed deleted successfully.");
          GetPopularPost(true);
        } else {
          toster.current.success("My feed deleted successfully.");
          GetFeed(true);
        }
        document.getElementById("delete-post").click();
      } catch (err) {
        setFeedLst(previousFeedLst);
      }
    }
  };

  async function fetchEmployeeData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 5000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesList = await getEmployeeList(params);
      let FeedEmpDetails = employeesList?.Data?.filter(
        (el) => el?.EmpId === feedLst[0]?.ModifiedBy
      );
      setFeedEmployeeDetails(FeedEmpDetails[0]);
      setEmployee(employeesList.Data);
    } catch (error) { }
  }

  async function FeedPostComment(Feedlst, mentionedArr, CommentText, FeedId) {
    if (CommentText) {
      const body = {
        FeedId: FeedId,
        EmpId: userDetails?.EmpId,
        ParentCommentId: 0,
        Comment: CommentText,
        PostMentions: mentionedArr,
      };
      try {
        await feedPostComment(body);
        toster.current.success("Comment added successfully.");
        setImagePath([]);
        setMentionedArr([]);
        setFeedText("");
        setUpdatedPage(1);
        setPage(1);
        setHasMore(true);
        setFeedLst((prev) =>
          prev.map((item, idx) =>
            item.Id === FeedId
              ? {
                ...item,
                LastComment: CommentText,
                LastCommentBy: userDetails?.FullName,
                LastCommentById: userDetails?.EmpId,
                LastCommentByProfilePic: userDetails?.ProfileImage,
                LastCommentDate: currentTime,
                PostMentions: mentionedArr,
                LastCommentGUID: userDetails?.GUID,
                TotalComments: item.TotalComments + 1
              }
              : idx === feedLst?.findIndex((f) => f.FeedId === FeedId)
                ? { ...item, LastComment: CommentText }
                : item
          )
        );
      } catch (error) {
        toster.current.error(ERROR_LIST?.FeedPostOnFeedDetails);
      }
    } else {
      toster.current.error(ERROR_LIST?.FeedPostOnFeedDetails);
    }
  }

  async function FeedCommentList() {
    const body = {
      LoggedInUserId: userDetails?.EmpId,
      FeedId: 0,
      FeedGUID: "",
      pageNumber: 1,
      pageSize: 10,
    };
    try {
      await feedCommentList(body);
    } catch (error) {
      toster.current.error(ERROR_LIST?.FeedPostOnFeedDetails);
    }
  }

  useEffect(() => {
    let NewSuggestion = selectedFeedText?.map((emp) => ({
      MentionedName: emp.FullName,
      MentionedId: emp.Id,
      CommentId: 0,
    }));
    setMentionedArr(NewSuggestion);
  }, [feedLst, selectedFeedText, ImagePath]);

  const reportPostValidation = Yup.object().shape({
    subject: Yup.string().required("Subject name is required"),
    desc: Yup.string().required("Title desc is required"),
    url: Yup.string(),
  });

  const reportPostForm = useFormik({
    initialValues: {
      subject: "",
      desc: "",
      url: "",
    },
    validationSchema: reportPostValidation,
    onSubmit: async (data) => {
      setIsLoading(true);
      data.PostId = feedId ?? 0;
      data.EmpId = userDetails?.EmpId;
      let reportPostList = await getReportPost(data);
      try {
        if (reportPostList) {
          reportPostForm.resetForm();
          setUploadedPostImages([]);
          toster.current.success("Report post successfully");
          document.getElementById("report-img").click();
          handalClosePopup();
          document.querySelector("#report-img .btn-close")?.click();
          setIsLoading(false);
        }
      } catch (error) {
        toster.current.error(ERROR_LIST.DefaultError);
        setIsLoading(false);
      }
    },
  });

  const handleFilePostChange = useCallback(async (event) => {
    const selectedFile = await event.target.files[0];
    setPostFile(selectedFile);
  }, []);

  useEffect(() => {
    if (postFile) {
      uploadPostDocFile();
    }
  }, [postFile]);

  async function uploadPostDocFile() {
    if (postFile) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("files", postFile);
      let params = {
        UploadType: UploadFile_KEYS?.Feed,
        RefId: feedId ?? 0,
      };
      const response = await await uploadDoc(params, formData);
      const data = await response;
      const postFormData = data?.Data[0];
      setUploadedPostImages(data?.Data[0]);
      reportPostForm.setFieldValue("url", postFormData);
      setIsLoading(false);
    } else {
      toster.current.warn("No file selected");
      setIsLoading(false);
    }
  }

  const EditFeedLst = (feedLst) => {
    setEditFeedLst(null);
    setTimeout(() => setEditFeedLst(feedLst), 0);
  };

  async function FeedLikePost(lst) {
    const updatedFeedList = feedLst.map((item) => {
      if (item.Id !== lst.Id) return item;
      let updatedItem = { ...item };
      if (item.IsLastCommentLikedByMe == 1) {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: Math.max(0, item.IsLastCommentLikedByMe - 1),
          LastCommentLikeCount: Math.max(0, item.LastCommentLikeCount - 1),
        };
      } else {
        updatedItem = {
          ...item,
          IsLastCommentLikedByMe: item.IsLastCommentLikedByMe + 1,
          LastCommentLikeCount: item.LastCommentLikeCount + 1,
        };
      }
      return updatedItem;
    });
    setFeedLst(updatedFeedList);
    let isLike = lst.MyReaction !== "Like";
    const body = {
      FeedId: Number(lst.Id),
      CommentId: lst.LastCommentId || 0,
      ReactionById: userDetails?.EmpId,
      ReactionTypeId: 101,
      Reaction: "Like",
      IsLike: isLike,
    };
    try {
      await feedLikePost(body);
    } catch (error) {
      toster.current.warn(ERROR_LIST.DashboardLike);
    }
  }

  function markFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type;
  }

  async function PostMarkFeatured() {
    setIsLoading(true);
    const body = {
      PostId: MakeFeaturedFeedId,
    };
    try {
      await postMarkFeatured(body);
      history.push("/Feed/Featured");
      GetFeaturedPost(true);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }
  const renderFeedText1 = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let FeedText = text?.LastComment;
    let newText = FeedText?.replace(mentionRegex, (mention) => {
      return `<a href="/Profile/${text?.LastCommentGUID}">${mention?.Comment}</a>`;
    });
    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a  style={{ color: "#c4c6c7" }}>${hashtag}</a>`;
    });
    return { __html: newText };
  };

  const renderFeedText = (text) => {
    const mentionRegex = /@\w+/g;
    const hashtagRegex = /#\w+/g;
    let postMention = text?.PostMentions;
    let FeedText = text?.LastComment;
    let newText = FeedText?.replace(mentionRegex, (mention) => {
      let matchedMention = postMention?.find(
        (emp) => "@" + emp.MentionedName?.replace(/ /g, "") === mention
      );
      if (!matchedMention) {
        return mention.replace("@", "");
      }
      return `<a href="/Profile/${matchedMention.MentionedUserId}">${matchedMention.MentionedName}</a>`;
    });
    newText = newText?.replace(hashtagRegex, (hashtag) => {
      return `<a style="color: #c4c6c7">${hashtag}</a>`;
    });
    return { __html: newText };
  };

  async function GetFeedCount(EmpId, OrgId) {
    setIsUserCountloading(true);
    let UserEmpId;
    let UserOrgId;
    let body = {
      EmpId: EmpId,
      OrgId: OrgId,
    };
    try {
      let feedCountList = await getFeedCount(body);
      setFeedCount(feedCountList?.Data[0]);
      setIsUserCountloading(false);
    } catch (error) {
      setIsUserCountloading(false);
      toster.current.error(ERROR_LIST?.FeedCount);
    }
  }

  const permissionFeaturedPostGranted = () => {
    userPermissions.map((UserPermission) => {
      if (UserPermission.PermissionName == "Feed.Edit") {
        setFeaturedPostEdit(true);
      } else if (UserPermission.PermissionName == "Feed.Report") {
        setFeaturedPostReport(true);
      } else if (UserPermission.PermissionName == "Feed.Delete") {
        setFeaturedPostDelete(true);
      } else if (UserPermission.PermissionName == "Feed.Featured") {
        setFeaturedPostFeatured(true);
      }
    });
  };

  function markUnFeatured(feedId, type) {
    MakeFeaturedFeedId = feedId;
    isFeaturedType = type;
  }

  async function PostMarkUnFeatured() {
    const previousFeedLst = [...feedLst];
    setFeedLst((prev) => {
      const newList = prev.map((item) => {
        if (item.Id === MakeFeaturedFeedId) {
          return {
            ...item,
            IsFeatured: 0,
          };
        }
        return item;
      });
      return newList;
    });
    const body = {
      PostId: MakeFeaturedFeedId,
    };
    try {
      await postMarkUnFeatured(body);
      if (location?.pathname == "/Feed/Featured") {
        history?.push("/Dashboard");
      }
    } catch (error) {
      setFeedLst(previousFeedLst);
      toster.current.error(ERROR_LIST?.MakeFeatured);
    }
  }

  const goToPost = (feedlst) => {
    history.push(`/Feed/Post/${feedlst?.GUID}`);
  };


  return (
    <div className="position-relation">
      <div className="container-fluid">
        <FeedPost
          returnResponce={handleResponseFromB}
          editFeedLst={editFeedLst}
        />
        <div className="row g-3">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">
                {CheckURL == "/Feed/User" && "Posts"}{" "}
                {location?.pathname == "/Feed/Featured" && "Featured Posts"}
                {location?.pathname == "/Feed/Popular" && "Popular Posts"}
              </h2>
            </div>
            <div className="form-head mb-4 d-flex flex-wrap align-items-center"></div>
          </div>
          <div className="col-xl-3 first">
            <div className="col-xl-12 owl-co">
              <div className="">
                <div className="v">
                  <div className="profile-side-div">
                    <div className="profile card card-body px-2 pt-3 pb-0">
                      <div className="profile-head">
                        <div className="photo-content">
                          <div className="cover-photo"></div>
                        </div>
                        <div className="profile-info">
                          <div className="profile-photo">
                            <img
                              src={userDetail?.UserImage || defaultImage}
                              onError={handleImageError}
                              className="img-fluid rounded-circle"
                              alt={userDetail?.UserName}
                            />
                          </div>
                          <div
                            className="profile-details text-center mt-3"
                            style={{ display: "block" }}
                          >
                            <div className="profile-name px-3 pt-0 profile-names">
                              <h4 className="text-primary mb-2">
                                {userDetail?.UserName}
                              </h4>
                              <div className="text-primary mb-2">
                                <Link to={`/Profile/${userDetail?.GUID}`}>
                                  View Profile
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {IsUserCountloading ? (
              <Skeleton height="30%" width="100%" />
            ) : (
              <div className="col-xl-12">
                <div className="post-statistic">
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Dashboard">
                      {" "}
                      <h5>{feedCount?.TotalPostCount}</h5>
                      <p>Total Posts</p>
                    </Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Feed/Featured">
                      {" "}
                      <h5>{feedCount?.FeaturedPostCount}</h5>
                      <p>Featured Posts</p>
                    </Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to="/Feed/Popular">
                      <h5>{feedCount?.PopularPostCount}</h5>
                      <p>Popular Posts</p>
                    </Link>
                  </div>
                  <div className="inner" style={{ cursor: "pointer" }}>
                    <Link to={`/Feed/User/${userDetail?.GUID}`}>
                      {" "}
                      <h5>{feedCount?.UserPostCount}</h5>
                      <p>{userDetail?.UserName?.split(" ")[0]}'s Posts</p>
                    </Link>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="col-xl-6 second">
            {Isloading ? (
              <Skeleton height="100%" width="100%" />
            ) : (
              <InfiniteScroll
                dataLength={feedLst?.length || 0}
                next={() => {
                  // if (!isFetching) {
                  if (location?.pathname === "/Feed/Featured") {
                    GetFeaturedPost(false);
                    // setTimeout(() => GetFeaturedPost(false), 1000)
                  } else if (location?.pathname === "/Feed/Popular") {
                    setTimeout(() => GetPopularPost(false), 700);
                  } else {
                    setTimeout(() => GetFeed(false), 700);
                  }
                  // }
                }}
                hasMore={hasMore}
                scrollableTarget="scrollableDiv"
              >
                {feedLst?.map((feedlst, index) => (
                  <div className="col-xl-12" key={index}>
                    <div
                      className=""
                      style={{ background: "none", boxShadow: "none" }}
                    >
                      <div className="">
                        <div
                          id="feed-post-1"
                          className="card is-post single-post-detail" onClick={() => goToPost(feedlst)}
                        >
                          <div className="content-wrap">
                            <div className="card-heading" key={feedlst.Id}>
                              <a>
                                <div
                                  id="myDIV2"
                                  style={{
                                    display:
                                      visibleId === feedlst.Id
                                        ? "block"
                                        : "none",
                                  }}
                                >
                                  {(featuredPostEdit ||
                                    feedlst?.CreatedBy ==
                                    userDetails?.EmpId) && (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="dropdown-item"
                                        onClick={() => EditFeedLst(feedlst)}
                                        aria-expanded="false"
                                        data-toggle="tooltip"
                                        data-placement="right"
                                        data-bs-toggle="modal"
                                        data-bs-target="#feed-org"
                                        title="Edit"
                                      >
                                        <div className="media">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-pencil-square"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                                            <path
                                              fillRule="evenodd"
                                              d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"
                                            />
                                          </svg>
                                          <div className="media-content">
                                            <h3>Edit</h3>
                                          </div>
                                        </div>
                                      </a>
                                    )}
                                  {(featuredPostDelete ||
                                    feedlst?.CreatedBy ==
                                    userDetails?.EmpId) && (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="dropdown-item"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delete-post"
                                        onClick={() => setDeleteId(feedlst?.Id)}
                                      >
                                        <div className="media">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-trash"
                                            viewBox="0 0 16 16"
                                            title="Delete"
                                          >
                                            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                                            <path
                                              fillRule="evenodd"
                                              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
                                            />
                                          </svg>
                                          <div className="media-content">
                                            <h3>Delete</h3>
                                          </div>
                                        </div>
                                      </a>
                                    )}
                                  {feedlst?.CreatedBy !== userDetails?.EmpId &&
                                    featuredPostReport && (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="dropdown-item"
                                        data-bs-toggle="modal"
                                        data-bs-target="#report-img"
                                        onClick={() => {
                                          addReportPost();
                                          setFeedId(feedlst?.Id);
                                        }}
                                      >
                                        <div className="media">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="feather feather-flag mr-2"
                                            title="Report"
                                          >
                                            <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                            <line
                                              x1="4"
                                              y1="22"
                                              x2="4"
                                              y2="15"
                                            ></line>
                                          </svg>
                                          <div className="media-content">
                                            <h3>Report this post</h3>
                                          </div>
                                        </div>
                                      </a>
                                    )}
                                  {featuredPostFeatured &&
                                    feedlst?.IsFeatured == 0 &&
                                    location?.pathname != "/Feed/Featured" && (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="dropdown-item"
                                        data-bs-toggle="modal"
                                        data-bs-target="#featured-post"
                                        onClick={() =>
                                          markFeatured(feedlst?.Id, 1)
                                        }
                                      >
                                        <div className="media">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-file-earmark-check"
                                            viewBox="0 0 16 16"
                                            title="Featured"
                                          >
                                            <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                          </svg>
                                          <div className="media-content">
                                            <h3>Mark as Featured</h3>
                                          </div>
                                        </div>
                                      </a>
                                    )}
                                  {featuredPostFeatured &&
                                    feedlst?.IsFeatured === 1 && (
                                      <a
                                        style={{ cursor: "pointer" }}
                                        className="dropdown-item"
                                        data-bs-toggle="modal"
                                        data-bs-target="#featured-post"
                                        onClick={() =>
                                          markUnFeatured(feedlst?.Id, 2)
                                        }
                                      >
                                        <div className="media">
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            className="bi bi-file-earmark-check"
                                            viewBox="0 0 16 16"
                                            title="Unfeatured"
                                          >
                                            <path d="M10.854 7.854a.5.5 0 0 0-.708-.708L7.5 9.793 6.354 8.646a.5.5 0 1 0-.708.708l1.5 1.5a.5.5 0 0 0 .708 0z" />
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                          </svg>
                                          <div className="media-content">
                                            <h3>Mark as Unfeatured</h3>
                                          </div>
                                        </div>
                                      </a>
                                    )}
                                </div>
                                <div className="user-block d-flex">
                                  <div className="image">
                                    <img
                                      src={
                                        `${feedlst?.ProfilePic}` || defaultImage
                                      }
                                      onError={handleImageError}
                                      width="32"
                                      style={{ opacity: "1" }}
                                      data-demo-src="/images/main-body/1.jpg"
                                      data-user-popover="1"
                                      alt=""
                                    />
                                  </div>
                                  <div className="user-info mt-2">
                                    <Link
                                      to={`/Profile/${feedlst?.PostedByGUID}`}
                                      onClick={(e) => e.stopPropagation()}
                                      className="atag"
                                    >
                                      {feedlst?.PostedBy}
                                    </Link>
                                    <span className="time">
                                      {moment(feedlst?.CreatedDate).format(
                                        "MMMM Do YYYY, h:mm a"
                                      )}
                                    </span>
                                  </div>
                                </div>
                              </a>
                              <div
                                className="dropdown is-spaced is-right is-neutral dropdown-trigger d-flex align-items-center"
                                style={{ gap: "5px" }}
                              >
                                {feedlst?.IsFeatured == 1 && (
                                  <div className="featured-star" key={index}>
                                    <img
                                      src="/images/IsFeturedImage.png"
                                      title="Featured Post"
                                      data-user-popover="1"
                                      alt=""
                                    />
                                  </div>
                                )}
                                <div>
                                  <div
                                    className="button"
                                    onClick={() => toggleVisibility(feedlst.Id)}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="feather feather-more-vertical"
                                    >
                                      <circle cx="12" cy="12" r="1"></circle>
                                      <circle cx="12" cy="5" r="1"></circle>
                                      <circle cx="12" cy="19" r="1"></circle>
                                    </svg>
                                  </div>
                                </div>
                                <div className="dropdown-menu" role="menu">
                                  <div className="dropdown-content">
                                    <a href="#" className="dropdown-item">
                                      <div className="media">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="feather feather-bookmark"
                                        >
                                          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
                                        </svg>
                                        <div className="media-content">
                                          <h3>Bookmark</h3>
                                          <small>
                                            Add this post to your bookmarks.
                                          </small>
                                        </div>
                                      </div>
                                    </a>
                                    <a className="dropdown-item">
                                      <div className="media">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="feather feather-bell"
                                        >
                                          <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                                          <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
                                        </svg>
                                        <div className="media-content">
                                          <h3>Notify me</h3>
                                          <small>Send me the updates.</small>
                                        </div>
                                      </div>
                                    </a>
                                    <hr className="dropdown-divider" />
                                    <a href="#" className="dropdown-item">
                                      <div className="media">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="24"
                                          height="24"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          stroke="currentColor"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          className="feather feather-flag"
                                        >
                                          <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path>
                                          <line
                                            x1="4"
                                            y1="22"
                                            x2="4"
                                            y2="15"
                                          ></line>
                                        </svg>
                                        <div className="media-content">
                                          <h3>Flag</h3>
                                          <small>
                                            In case of inappropriate content.
                                          </small>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div key={index} className="card-body">
                              <FeedCarousel
                                templateData={feedlst}
                                itemIndex={index}
                                onPassResponse={handleLastName}
                              />
                            </div>
                            <div className="card-footer d-block commentdiv" onClick={(e) => e.stopPropagation()} >
                              <a>
                                <div className="send-output">
                                  <img
                                    className="pro-img"
                                    src={
                                      userDetails?.ProfileImage || defaultImage
                                    }
                                    onError={handleImageError}
                                    title={userDetails?.FullName}
                                    data-user-popover="1"
                                    alt=""
                                  />
                                  <Commnent
                                    sendCommentData={FeedPostComment}
                                    reciveCommentData={feedText}
                                    employeesList={employee}
                                    commentType={feedlst?.Id}
                                  />
                                </div>
                              </a>
                              {feedlst?.LastComment && (
                                <div className="d-flex mt-4">
                                  <div className="likers-group">
                                    <img
                                      src={
                                        feedlst?.LastCommentByProfilePic ||
                                        defaultImage
                                      }
                                      onError={handleImageError}
                                      title={feedlst?.LastCommentByProfilePic}
                                      data-user-popover="1"
                                      alt=""
                                    />
                                  </div>
                                  <div className="likers-text">
                                    <p>
                                      <Link
                                        to={`/Profile/${feedlst?.LastCommentGUID}`}
                                      >
                                        {feedlst?.LastCommentBy}
                                      </Link>
                                    </p>
                                    <p
                                      className="small break-text" style={{ whiteSpace: "pre-wrap" }}
                                      dangerouslySetInnerHTML={renderFeedText(
                                        feedlst
                                      )}
                                    ></p>
                                    <p>
                                      <a className="me-2">
                                        {feedlst?.IsLastCommentLikedByMe ? (
                                          <a className="hover-like-box"
                                            onClick={() =>
                                              FeedLikePost(feedlst)
                                            }
                                          >
                                            <svg
                                              xmlns="http://www.w3.org/2000/svg"
                                              width="16"
                                              height="16"
                                              fill="red"
                                              className="bi bi-heart-fill"
                                              viewBox="0 0 16 16"
                                            >
                                              <path
                                                fillRule="evenodd"
                                                d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314"
                                              />
                                            </svg>
                                          </a>
                                        ) : (
                                          <a
                                            onClick={() =>
                                              FeedLikePost(feedlst)
                                            }
                                          >
                                            <i className="fa fa-heart-o like-button"></i>
                                          </a>
                                        )}

                                        <b>
                                          {feedlst?.LastCommentLikeCount >= 1
                                            ? feedlst?.LastCommentLikeCount
                                            : ""}
                                        </b>
                                      </a>
                                      <Link
                                        to={`/Feed/Post/${feedlst?.GUID}`}
                                        className="atag"
                                      >
                                        <a>
                                          <i
                                            className="fa fa-quote-right"
                                            aria-hidden="true"
                                          >
                                            &nbsp; Quote
                                          </i>
                                        </a>
                                      </Link>
                                      <span className="like-overlay"></span>
                                    </p>
                                  </div>
                                  <div className="social-count">
                                    <div className="likes-count">
                                      <PostDate
                                        LastCommentDate={
                                          feedlst?.LastCommentDate
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </InfiniteScroll>
            )}
            {isSecondLoading && <p>Loading....</p>}
            <div
              className="modal fade custom-modal-area"
              id="report-img"
              tabIndex="-1"
              aria-hidden="true"
            >
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content add-editexperience">
                  <div className="modal-header">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="backimg"
                    />
                    <div className="img">
                      <img src="/images/popup-icons/featured-post.png" />
                    </div>
                    <button
                      type="button"
                      className="btn-close"
                      data-bs-dismiss="modal"
                      onClick={() => handalClosePopup}
                    ></button>
                  </div>

                  <div className="modal-body ">
                    <img src="/images/popup-icons/report.png" />
                    <h5 className="modal-title text-center">
                      {" "}
                      Do you sure report ?
                    </h5>
                    <form>
                      <div className="row  mt-4 gx-3 gy-2">
                        <div className="form-group mb-3 ">
                          <label className="form-label">Subject Name</label>
                          <input
                            type="text"
                            name="subject"
                            className={
                              "form-control" +
                              (reportPostForm.errors.subject &&
                                reportPostForm.touched.subject
                                ? " is-invalid"
                                : "")
                            }
                            onChange={reportPostForm.handleChange}
                            value={reportPostForm.values.subject}
                            placeholder="Subject Name"
                          />{" "}
                          <div className="invalid-feedback">
                            {reportPostForm.errors.subject &&
                              reportPostForm.touched.subject
                              ? reportPostForm.errors.subject
                              : null}
                          </div>
                        </div>
                        <div className="form-group mb-3 ">
                          <label className="form-label">
                            <i
                              className="fa fa-info-circle"
                              aria-hidden="true"
                            ></i>{" "}
                            Help us understand what's happening.
                          </label>
                          <input
                            type="text"
                            name="desc"
                            className={
                              "form-control" +
                              (reportPostForm.errors.desc &&
                                reportPostForm.touched.desc
                                ? " is-invalid"
                                : "")
                            }
                            onChange={reportPostForm.handleChange}
                            value={reportPostForm.values.desc}
                            placeholder="Description"
                          />
                          <div className="invalid-feedback">
                            {reportPostForm.errors.desc &&
                              reportPostForm.touched.desc
                              ? reportPostForm.errors.desc
                              : null}
                          </div>
                        </div>
                        <div className="form-group mb-3">
                          <div className="upload__box">
                            {uploadedPostImages.length <= 0 && (
                              <div className="upload__btn-box">
                                <label className="d-block">Upload Doc</label>
                                <label className="upload__btn">
                                  <p className="m-0">
                                    <i className="fa fa-plus-square-o mr-3"></i>
                                    Upload Doc
                                  </p>
                                  <input
                                    type="file"
                                    multiple=""
                                    data-max_length="20"
                                    className="upload__inputfile"
                                    onChange={handleFilePostChange}
                                  />
                                </label>
                              </div>
                            )}
                            {uploadedPostImages?.length != 0 && (
                              <div className="upload__img-wrap">
                                <div className="upload__img-box">
                                  <span
                                    className="closeresume_Report"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleDeleteImage()}
                                    title="Delete"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      className="bi bi-x"
                                      viewBox="0 0 16 16"
                                    >
                                      {" "}
                                      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                    </svg>
                                  </span>
                                  <img
                                    src={uploadedPostImages}
                                    className="w-100"
                                  />
                                </div>
                              </div>
                            )}
                          </div>{" "}
                        </div>
                      </div>
                    </form>
                    <div className="modal-footer m-auto">
                      <button
                        type="button"
                        className="btn btn-danger light"
                        data-bs-dismiss="modal"
                        onClick={handalClosePopup}
                      >
                        Close
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        onClick={reportPostForm.handleSubmit}
                      >
                        Send
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal fade" id="delete-post">
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content delete-holiday">
                  <div className="modal-header">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="backimg"
                    />

                    <div className="img">
                      <img src="/images/org-img/leave/trash.png" />
                    </div>
                  </div>
                  <div className="modal-body text-center">
                    <strong className="modal-title">Are you sure?</strong>
                    <p>Do you really want to delete this post?</p>
                  </div>
                  <div className="modal-footer m-auto">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="deletebtn-click"
                      data-bs-dismiss="modal"
                      onClick={() => DeleteFeedPost()}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal fade" id="featured-post">
              <div
                className="modal-dialog modal-dialog-centered"
                role="document"
              >
                <div className="modal-content featured-post-confirmation">
                  <div className="modal-header">
                    <img
                      src="/images/org-img/leave/popup-backimg.png"
                      className="backimg"
                    />
                    <div className="img">
                      <img src="/images/popup-icons/featured-post.png" />
                    </div>
                  </div>
                  <div className="modal-body text-center">
                    <strong className="modal-title">Are you sure?</strong>
                    <p>
                      Do you really want to {isFeaturedType == 1 && "feature"}{" "}
                      {isFeaturedType == 2 && "unfeature"} this post ?
                    </p>
                  </div>
                  <div className="modal-footer m-auto">
                    <button
                      type="button"
                      className="cancelbtn-click"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </button>
                    {isFeaturedType == 1 && (
                      <button
                        type="button"
                        className="savebtn-click"
                        data-bs-dismiss="modal"
                        onClick={() => PostMarkFeatured()}
                      >
                        Feature
                      </button>
                    )}{" "}
                    {isFeaturedType == 2 && (
                      <button
                        type="button"
                        className="savebtn-click"
                        data-bs-dismiss="modal"
                        onClick={() => PostMarkUnFeatured()}
                      >
                        Unfeature
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3 third">
            <FollowUpSuggestions EmpId={feedEmployeeDetails?.EmpId} />
            {location?.pathname == "/Feed/Featured" ? (
              <div className="col-xl-12 owl-co owl-co2 col-sm-6">
                <div className="card award">
                  <div className="card-body">
                    <div className="custom-tab-1 custom-tab-11">
                      <div className="slide22">
                        <strong className="upcome">{T("Popular Posts")}</strong>
                        <Link to="/Feed/Popular" className="more-icon">
                          <i className="fa fa-angle-right"></i>
                        </Link>
                        <DashboardPopularPost />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="col-xl-12 owl-co owl-co2 col-sm-6">
                <div className="card award">
                  <div className="card-body">
                    <div className="custom-tab-1 custom-tab-11">
                      <div className="slide22">
                        <strong className="upcome">
                          {T("Featured Posts")}
                        </strong>
                        <Link to="/Feed/Featured" className="more-icon">
                          <i className="fa fa-angle-right"></i>
                        </Link>
                        <DashboardFeatureAndPopularPost />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {CheckURL == "/Feed/User" && (
              <div className="col-xl-12 owl-co owl-co2 col-sm-6">
                <div className="card award">
                  <div className="card-body">
                    <div className="custom-tab-1 custom-tab-11">
                      <div className="slide22">
                        <strong className="upcome">{T("Popular Posts")}</strong>
                        <Link to="/Feed/Popular" className="more-icon">
                          <i className="fa fa-angle-right"></i>
                        </Link>
                        <DashboardPopularPost />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default FeaturedPost;
